import { __decorate, __metadata, __awaiter, __param } from 'tslib';
import { DatePipe, CommonModule } from '@angular/common';
import { Injectable, Inject, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { AlertController, IonicModule } from '@ionic/angular';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { ConfigService, SpeViewNAccountProxy, SpeNOpenAccountProxy, SpeNAccountProxy, SpeJCashOutProxy, SpeJCheckEventProxy, SpeJFundsProxy, SpeViewNDashboardClientProxy, SpeViewNStatamentProxy, SpeJFilesProxy, SpeNPaymentVoucherProxy, SpeJCnabProxy, SpeNAccountsProxy, SpeViewNBackoficceAccountProxy, SpeViewNCnabProxy, SpeNPaymentProxy, SpeViewNPaymentProxy, UiPxCashOutModule } from '@wlp/ui-px-cashout';
export { AbstractPaymentLotDetail, ExtractConciliationCnabResponse, PaymentLotDetailBillet, PaymentLotDetailHistory, PaymentLotDetailOnUs, PaymentLotDetailPix, PaymentLotDetailTed, PaymentLotDetailTransfer, PaymentLotDto, PaymentLotStatusDefaultEnum, PaymentLotStatusLineEnum, PaymentLotTypeKeyPixEnum, PaymentLotTypeLotEnum } from '@wlp/ui-px-cashout';
import { BaseService, DocumentValidator, UfService, CreditCardFlagService, ErrorMessageService, PrintService, Base64Service } from '@wlp/ui-bs-util';
import { BehaviorSubject, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SpeViewNPrePixProxy, UiPxPixModule } from '@wlp/ui-px-pix';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';

let AccountDataService = class AccountDataService extends BaseService {
    constructor(storage, configService, speViewNAccountProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speViewNAccountProxy = speViewNAccountProxy;
    }
    /**
     * retorna os dados pessoais da conta usando o uuid como parametro
     * @param uuidAccount
     */
    getAccountPaymentPerson(uuid) {
        return this.speViewNAccountProxy.getAccountPaymentPerson(uuid);
    }
};
AccountDataService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeViewNAccountProxy])
], AccountDataService);

class AddCardResponse {
}

let AddCardService = class AddCardService extends BaseService {
    constructor(storage, formBuilder, ufService, creditCardFlagService, configService, speNOpenAccountProxy, speNAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.formBuilder = formBuilder;
        this.ufService = ufService;
        this.creditCardFlagService = creditCardFlagService;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speNAccountProxy = speNAccountProxy;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            nameCard: [
                {
                    type: 'minlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NAME_CARD.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'required',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NAME_CARD.MESSAGE.REQUIRED'
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NAME_CARD.MESSAGE.MAX_LENGTH',
                    param: { minLength: 100 }
                }
            ],
            cpf: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.CPF.MESSAGE.CPF_NOT_VALID' },
            ],
            numberCard: [
                {
                    type: 'pattern',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NUMBER_CARD.MESSAGE.PATTERN'
                },
                {
                    type: 'required',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NUMBER_CARD.MESSAGE.REQUIRED'
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.NUMBER_CARD.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 16 }
                }
            ],
            validityMonth: [
                {
                    type: 'pattern',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.PATTERN'
                },
                {
                    type: 'required',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.REQUIRED'
                },
                {
                    type: 'min',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.MIN'
                },
                {
                    type: 'max',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.MAX'
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_MONTH.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 2 }
                }
            ],
            validityYear: [
                {
                    type: 'pattern',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_YEAR.MESSAGE.PATTERN'
                },
                {
                    type: 'required',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_YEAR.MESSAGE.REQUIRED'
                },
                {
                    type: 'min',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_YEAR.MESSAGE.MIN',
                    param: {
                        min: new Date().getFullYear()
                    }
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.VALIDITY_YEAR.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 2 }
                }
            ],
            postalCode: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.POSTAL_CODE.MESSAGE.REQUIRED' },
                { type: 'minlength', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.POSTAL_CODE.MESSAGE.MIN_LENGTH', param: { minLength: 9 } },
                { type: 'pattern', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.POSTAL_CODE.MESSAGE.PATTERN' }
            ],
            address: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 5 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 200 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            numberAddress: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NUMBER_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'maxlength', param: { maxLength: 5 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NUMBER_ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            complementAddress: [
                { type: 'maxlength', param: { maxLength: 60 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.COMPLEMENT_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            neighborhood: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 5 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NEIGHBORHOOD.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 60 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.NEIGHBORHOOD.MESSAGE.MAX_LENGTH' }
            ],
            cityAddress: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.CITY_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 5 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.CITY_ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.CITY_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            uf: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.ADDRESS_FORM.UF.MESSAGE.REQUIRED' }
            ],
            cvv: [
                { type: 'required', message: 'CASH_OUT.ADD_CARD.FORM.CARD_FORM.CVV.MESSAGE.REQUIRED' },
            ],
            country: [
            // { type: 'required', message: 'Campo obrigatório' },
            ],
        };
        this.imageFlagCard = null;
    }
    getErrorMessage() {
        return this.errorMessages;
    }
    getCardForm() {
        this.formAddCard = this.formBuilder.group({
            nameCard: new FormControl('', Validators.compose([
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.required,
            ])),
            cpf: new FormControl('', Validators.compose([
                DocumentValidator.isValidCPF,
                Validators.required,
            ])),
            numberCard: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(16),
                Validators.pattern('^[0-9]*$')
            ])),
            validityMonth: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(2),
                Validators.min(1),
                Validators.max(12),
                Validators.pattern('^[0-9]*$')
            ])),
            validityYear: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(2),
                Validators.pattern('^[0-9]*$')
            ])),
            postalCode: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$')
            ])),
            address: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(200),
            ])),
            numberAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(30),
            ])),
            complementAddress: new FormControl('', Validators.compose([
                Validators.maxLength(60),
            ])),
            neighborhood: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(60)
            ])),
            cityAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(30)
            ])),
            uf: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2)
            ])),
            brand: new FormControl(''),
            cvv: new FormControl('', Validators.compose([
            // Validators.required,
            ])),
        });
        return this.formAddCard;
    }
    searchPostalCode(zipcode) {
        this.speNOpenAccountProxy
            .getCep(zipcode)
            .subscribe(data => this.updateAddress(data), error => this.errorMessageService.getError(error));
    }
    getUf() {
        return this.ufService.getListUf();
    }
    findCardFlag(numberCard) {
        return this.creditCardFlagService.getImageFlag(numberCard);
    }
    findCardFlagForName(nameCard) {
        return this.creditCardFlagService.getImageFlagForName(nameCard);
    }
    findNameCardFlag(numberCard) {
        return this.creditCardFlagService.getNameFlag(numberCard);
    }
    getErrorCardAdd(error) {
        this.errorMessageService.getError(error);
    }
    syncForm(addCard) {
        this.formAddCard.patchValue({
            nameCard: addCard.nameCard,
            cpf: addCard.cpf,
            numberCard: addCard.numberCard,
            validityMonth: addCard.validityMonth,
            validityYear: addCard.validityYear,
            postalCode: addCard.postalCode,
            numberAddress: addCard.numberAddress,
            address: addCard.address,
            cityAddress: addCard.cityAddress,
            neighborhood: addCard.neighborhood,
            complementAddress: addCard.complementAddress,
            uf: addCard.uf,
        });
    }
    updateAddress(address) {
        this.formAddCard.patchValue({
            address: address.logradouro.toUpperCase(),
            neighborhood: address.bairro.toUpperCase(),
            cityAddress: address.localidade.toUpperCase(),
            uf: address.uf.toUpperCase(),
        });
    }
    prepareAddCard(form) {
        const addCardResponse = new AddCardResponse();
        const data = form.getRawValue();
        addCardResponse.nameCard = data.nameCard;
        addCardResponse.cpf = data.cpf;
        addCardResponse.numberCard = data.numberCard;
        addCardResponse.validityMonth = data.validityMonth;
        addCardResponse.validityYear = data.validityYear;
        addCardResponse.postalCode = data.postalCode;
        addCardResponse.numberAddress = data.numberAddress;
        addCardResponse.address = data.address;
        addCardResponse.cityAddress = data.cityAddress;
        addCardResponse.neighborhood = data.neighborhood;
        addCardResponse.complementAddress = data.complementAddress;
        addCardResponse.uf = data.uf;
        return addCardResponse;
    }
};
AddCardService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        FormBuilder,
        UfService,
        CreditCardFlagService,
        ConfigService,
        SpeNOpenAccountProxy,
        SpeNAccountProxy,
        ErrorMessageService])
], AddCardService);

let BilletService = class BilletService extends BaseService {
    constructor(storage, configService, fb, speJCashOutProxy, speJCheckEventProxy, printService, paramInterface) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.fb = fb;
        this.speJCashOutProxy = speJCashOutProxy;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.printService = printService;
        this.paramInterface = paramInterface;
        this.billetSubject$ = new BehaviorSubject(null);
        this.behaviorExtractBillet = new BehaviorSubject([]);
    }
    setBilletSubject(data) {
        this.billetSubject$.next(data);
    }
    /**
     * Criação do form billet
     */
    getBilletForm() {
        this.billetForm = this.fb.group({
            brCode: ['', Validators.compose([Validators.required, Validators.minLength(44), Validators.maxLength(60)])],
        });
        return this.billetForm;
    }
    /**
     * Criação do form billetExtract
     */
    getBilletExtractForm() {
        this.billetExtractForm = this.fb.group({
            nameBeneficiary: [''],
            brCode: [''],
            namePayer: [''],
            cpfPayer: [''],
            amountPaid: [''],
            discount: [''],
            interest: [''],
            fine: [''],
            totalPay: [''],
            datePay: [''],
            dateExpiration: [''],
            transactionIdConsult: [''],
            dateSchedule: [''],
            scheduled: [''],
        });
        return this.billetExtractForm;
    }
    /**
     * Criação do form billetExtract
     */
    getBilletResumeForm() {
        this.billetResumeForm = this.fb.group({
            nameBeneficiary: ['', [Validators.required]],
            bankBeneficiary: ['', [Validators.required]],
            brCode: ['', [Validators.required]],
            namePayer: ['', [Validators.required]],
            bankPayer: [''],
            cpfPayer: ['', [Validators.required]],
            amountPaid: ['', [Validators.required]],
            discount: [''],
            interest: [''],
            fine: [''],
            totalPay: ['', [Validators.required]],
            datePay: ['', [Validators.required]],
            dateExpiration: ['', [Validators.required]],
            editable: [''],
            identification: [''],
            transactionIdConsult: [''],
            maxPayment: [''],
            minPayment: [''],
            typeableLine: [''],
            dateSchedule: [''],
            scheduled: [''],
        });
        return this.billetResumeForm;
    }
    convertToDate(date) {
        if (date && typeof date === 'object' && date.constructor === Array) {
            if (date.length === 6) {
                return new Date(date[0], date[1] - 1, date[2], date[3], date[4], date[5]);
            }
            else if (date.length === 5) {
                return new Date(date[0], date[1] - 1, date[2], date[3], date[4]);
            }
            return new Date(date[0], date[1] - 1, date[2]);
        }
        return date;
    }
    formattedPipeDate(date) {
        return new DatePipe('en-US').transform(date, 'dd/MM/yyyy');
    }
    /**
     * Método responsavel por formatar os dados para o padrão adotado pelo form
     */
    formatData(data, namePayer, bankPayer, cpfPayer) {
        let dateExpiration;
        if (data && data.dueDate) {
            dateExpiration = this.convertToDate(data.dueDate);
        }
        let editable = false;
        if (data && data.tpAutcRecbtVlrDivgte) {
            editable = data.tpAutcRecbtVlrDivgte;
        }
        let identification = '';
        if (data && data.identification) {
            identification = data.identification;
        }
        const info = {
            editable: editable,
            nameBeneficiary: data.emitterName,
            bankBeneficiary: data.bankName,
            brCode: data.codeRead,
            namePayer,
            bankPayer,
            cpfPayer,
            amountPaid: data.valuePayment,
            discount: data.discountValue,
            interest: data.interestValue,
            fine: data.fineValue,
            totalPay: data.valuePayment,
            datePay: this.formattedPipeDate(new Date()),
            dateExpiration: this.formattedPipeDate(dateExpiration),
            identification: identification,
            transactionIdConsult: data.transactionIdConsult,
            maxPayment: data.maxPayment,
            minPayment: data.minPayment,
            typeableLine: data.typeableLine,
            dateSchedule: data.dateSchedule,
            scheduled: data.scheduled,
        };
        this.setBilletSubject(info);
        return info;
    }
    /**
     * Método responsavel por realizar a validação do codigo de barras
     * @param code
     */
    getBillet(code, isBarCode, uuidWhiteLabel, uuidAccountPayment) {
        let flag = false;
        if (this.paramInterface.device === 'APP' && isBarCode) {
            flag = true;
        }
        return this.speJCashOutProxy.postBillet(code, flag, uuidWhiteLabel, uuidAccountPayment);
    }
    /**
     * Método responsavel por retornar os dados sobre o resumo
     * de pagamento
     */
    getBilletResume() {
        const data = this.billetSubject$.value;
        this.billetResumeForm.patchValue(data);
        return this.billetResumeForm;
    }
    /**
     * Método reesponsavel por acionar o endpoint para salvar a transferencia e
     * encaminhar os dados para tela de extrato
     */
    saveBillet(info, uuidWhiteLabel, uuidAccount, token, tokenTransaction) {
        const data = {
            linePayment: info.brCode,
            typeableLine: info.typeableLine,
            identification: info.identification,
            transactionIdConsult: info.transactionIdConsult,
            value: info.totalPay,
            uuidAccountPayment: uuidAccount,
            uuidWhiteLabel: uuidWhiteLabel,
            dueDate: info.dueDate,
            codeAuthorization: token,
            tokenTransaction: tokenTransaction,
            dateSchedule: info.dateSchedule,
            scheduled: info.scheduled
        };
        this.businessBilletExtract = info;
        this.behaviorExtractBillet.next(this.businessBilletExtract);
        return this.speJCashOutProxy.postBilletConfirm(data);
    }
    /**
     * Método responsavel por retornar os dados sobre o comprovantes
     * de pagamento
     */
    getBilletExtract() {
        const data = this.billetSubject$.value;
        this.billetExtractForm.patchValue(data);
        return this.billetExtractForm;
    }
    /**
     * Método responsavel por gerar o comprovante em uma nova aba
     */
    print(html, css) {
        this.printService.print(html, css);
    }
    /**
     * @description Método responsavel por validar o saldo para pagamento
     */
    validateOperation(uuidWhiteLabel, uuidAccount, value) {
        return __awaiter(this, void 0, void 0, function* () {
            let sendingBody;
            let validateResponse;
            sendingBody = {
                codeOperation: '112',
                uuidAccountPayment: uuidAccount,
                uuidWhiteLabel: uuidWhiteLabel,
                valueOperation: value,
            };
            yield this.speJCheckEventProxy
                .validateOperation(sendingBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => err);
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Método fomata o valor de string e retorna um float
     */
    formatValue(value) {
        let dataValue = value.replace(/\./g, '');
        let dataValue2 = dataValue.replace(',', '.');
        return parseFloat(dataValue2);
    }
    getListBillet() {
        return this.behaviorExtractBillet;
    }
    /**
     * Método responsavel por criar o formulario para conter os dados de compensação do boleto
     * @returns
     */
    createFormLiquidation() {
        return this.fb.group({
            uuidWhiteLabel: ['', Validators.compose([Validators.required])],
            codeAuthorization: ['', Validators.compose([Validators.required])],
            uuidTransactionRechargeBillet: ['', Validators.compose([Validators.required])],
        });
    }
    /**
     * Método responsavel por realizar a compensação do boleto
     * @param uuidAccountPayment
     * @param form
     */
    liquidation(uuidAccountPayment, form) {
        return this.speJCashOutProxy.postLiquidation(uuidAccountPayment, form);
    }
};
BilletService = __decorate([
    Injectable(),
    __param(6, Inject(APP_PARAMETER)),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        FormBuilder,
        SpeJCashOutProxy,
        SpeJCheckEventProxy,
        PrintService, Object])
], BilletService);

class ExtractFutureResponse {
}

class ExtractDigitalAccountResponse {
}

let ExtractDigitalAccountService = class ExtractDigitalAccountService extends BaseService {
    constructor(speJFundsProxy, errorMessageService, configService, storage, speViewNDashboardClientProxy, speViewNStatamentProxy, dashboardService) {
        super(storage, configService);
        this.speJFundsProxy = speJFundsProxy;
        this.errorMessageService = errorMessageService;
        this.configService = configService;
        this.storage = storage;
        this.speViewNDashboardClientProxy = speViewNDashboardClientProxy;
        this.speViewNStatamentProxy = speViewNStatamentProxy;
        this.dashboardService = dashboardService;
    }
    getStatement(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.speJFundsProxy
            .getCheckStatement(uuidWhiteLabel, uuidAccount, initial, end)
            .pipe(map(res => this.prepareExtract(res)));
    }
    getStatementFuture(uuidWhiteLabel, uuidAccount) {
        return this.speJFundsProxy
            .getCheckStatementFuture(uuidWhiteLabel, uuidAccount)
            .pipe(map(res => this.prepareExtractFuture(res)));
    }
    getStatementCard(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.speJFundsProxy
            .getCheckStatementCard(uuidWhiteLabel, uuidAccount, initial, end)
            .pipe(map(res => this.prepareExtract(res)));
    }
    getStatementByCard(uuidWhiteLabel, uuidAccount, uuidAccountPaymentCard, dateInitial, dateEnd) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.speJFundsProxy
            .getCheckStatementByCard(uuidWhiteLabel, uuidAccount, uuidAccountPaymentCard, initial, end)
            .pipe(map(res => this.prepareExtract(res)));
    }
    getStatementByCardDownload(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd, uuidAccountPaymentCard, format, cardNumber, nickName, colorCredit, colorDebit) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.speViewNDashboardClientProxy.downloadStatementByCard(uuidWhiteLabel, uuidAccount, initial, end, uuidAccountPaymentCard, format, cardNumber, nickName, colorCredit, colorCredit);
    }
    getErroMessage(err) {
        return this.errorMessageService.getError(err);
    }
    valueDisplayCreditOrDebit(extractDigitalAccount) {
        return !!extractDigitalAccount.credit ? extractDigitalAccount.credit : extractDigitalAccount.debit;
    }
    showIsBalance(typeStatement) {
        return Number(typeStatement) === 0;
    }
    showIsCreditOrDebit(typeStatement) {
        return Number(typeStatement) > 0;
    }
    isCredit(typeStatement) {
        return Number(typeStatement) === 1;
    }
    prepareExtract(listDataStatement) {
        let listExtract = [];
        listDataStatement
            .forEach(data => listExtract.push(this.mountExtractDigital(data)));
        return listExtract;
    }
    prepareExtractFuture(listDataStatementFuture) {
        let listExtractFuture = [];
        listDataStatementFuture
            .forEach(data => listExtractFuture.push(this.mountExtractFuture(data)));
        return listExtractFuture;
    }
    mountExtractFuture(dataStatementResponse) {
        const extractDigitalAccount = new ExtractFutureResponse();
        extractDigitalAccount.uuid = dataStatementResponse.uuid;
        extractDigitalAccount.uuidAccountPayment = dataStatementResponse.uuidAccountPayment;
        extractDigitalAccount.uuidWhiteLabel = dataStatementResponse.uuidWhiteLabel;
        extractDigitalAccount.operationDescription = dataStatementResponse.operationDescription;
        extractDigitalAccount.description = dataStatementResponse.description;
        extractDigitalAccount.credit = dataStatementResponse.credit;
        extractDigitalAccount.debit = dataStatementResponse.debit;
        extractDigitalAccount.balance = dataStatementResponse.balance;
        extractDigitalAccount.typeStatement = dataStatementResponse.typeStatement;
        extractDigitalAccount.transactionId = dataStatementResponse.transactionId;
        extractDigitalAccount.dateRegister = dataStatementResponse.dateRegister;
        extractDigitalAccount.hasVoucher = dataStatementResponse.hasVoucher;
        return extractDigitalAccount;
    }
    mountExtractDigital(dataStatementResponse) {
        const extractDigitalAccount = new ExtractDigitalAccountResponse();
        extractDigitalAccount.uuid = dataStatementResponse.uuid;
        extractDigitalAccount.transactionId = dataStatementResponse.transactionId;
        extractDigitalAccount.category = 'Outros';
        extractDigitalAccount.description = dataStatementResponse.description;
        extractDigitalAccount.icon = 'grid-outline';
        extractDigitalAccount.typeStatement = dataStatementResponse.typeStatement;
        extractDigitalAccount.balance = dataStatementResponse.balance;
        extractDigitalAccount.credit = dataStatementResponse.credit;
        extractDigitalAccount.debit = dataStatementResponse.debit;
        extractDigitalAccount.dateRegister = dataStatementResponse.dateRegister;
        extractDigitalAccount.operationDescription = dataStatementResponse.operationDescription;
        return extractDigitalAccount;
    }
    findExtractByTypeView(uuidAccountPayment, startDate, endDate, typeView, uuidOperation) {
        return this.speViewNStatamentProxy.findExtractByTypeView(uuidAccountPayment, startDate, endDate, typeView, uuidOperation);
    }
    findExtractByTypeViewPagination(uuidAccountPayment, startDate, endDate, typeView, page, pageSize, orderDate, uuidOperation) {
        return this.speViewNStatamentProxy.findExtractByTypeViewPagination(uuidAccountPayment, startDate, endDate, typeView, page, pageSize, orderDate, uuidOperation);
    }
    findByTypeOperation(uuidAccountPayment, type) {
        return this.speViewNStatamentProxy.findByTypeOperation(uuidAccountPayment, type);
    }
    downloadStatement(uuidWhiteLabel, uuidAccountPayment, startDate, endDate, typeView, format, uuidOperation, colorCredit, colorDebit) {
        return this.speViewNStatamentProxy.downloadStatementPagination(uuidWhiteLabel, uuidAccountPayment, startDate, endDate, typeView, format, uuidOperation, colorCredit, colorDebit);
    }
    downloadStatementPdf(content) {
        return this.dashboardService.downloadStatement(content);
    }
};
ExtractDigitalAccountService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeJFundsProxy,
        ErrorMessageService,
        ConfigService,
        Storage,
        SpeViewNDashboardClientProxy,
        SpeViewNStatamentProxy,
        SpeJFilesProxy])
], ExtractDigitalAccountService);

let ExtractService = class ExtractService extends BaseService {
    constructor(storage, configService, paymentService, dashboardClientService, dashboardService, speViewNAccountProxy, speJCnabProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.paymentService = paymentService;
        this.dashboardClientService = dashboardClientService;
        this.dashboardService = dashboardService;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.speJCnabProxy = speJCnabProxy;
    }
    /**
     * retorna uma transaction usando o id como parametro
     * @param transationId
     */
    getTransaction(transationId) {
        return this.paymentService.findTransactionIdConsult(transationId);
    }
    /**
     * retorna uma transaction usando o id como parametro
     * @param transationId
     */
    getTransactionv2(transationId) {
        return this.paymentService.findTransactionIdConsultv2(transationId);
    }
    getTransactionScheduled(uuidAccountPayment) {
        return this.paymentService.findAllScheduled(uuidAccountPayment);
    }
    /**
     * retorna uma transaction usando o id como parametro
     * @param uuidAccount
     */
    getAllTransactions(uuidAccount) {
        return this.paymentService.findAllAccountPayment(uuidAccount);
    }
    /**
     * Retorna uma transação passando o uuidAccount, e o periodo como parametro
     * @param uuidAccount
     */
    getTransactionsByPeriod(uuidAccount, startDate, endDate) {
        return this.paymentService.findPeriodByAccountPayment(uuidAccount, startDate, endDate);
    }
    getTransactionsByPeriodAndTypeVoucher(uuidAccount, typeVoucher, startDate, endDate) {
        return this.paymentService.findPeriodByAccountPaymentAndTypeVoucher(uuidAccount, typeVoucher, startDate, endDate);
    }
    getTransactionsByPeriodAndAccountDestination(uuidAccount, accountDestination, startDate, endDate) {
        return this.paymentService.findPeriodByAccountPaymentAndAccountDestination(uuidAccount, accountDestination, startDate, endDate);
    }
    getTransactionsByPeriodAndDocumentDestination(uuidAccount, documentDestination, startDate, endDate) {
        return this.paymentService.findPeriodByAccountPaymentAndAccountDestination(uuidAccount, documentDestination, startDate, endDate);
    }
    downloadStatement(uuidWhiteLabel, uuidAccountPayment, startDate, endDate, format, colorCredit, colorDebit) {
        const initial = this.formatDateToString(startDate);
        const end = this.formatDateToString(endDate);
        return this.dashboardClientService.downloadStatement(uuidWhiteLabel, uuidAccountPayment, initial, end, format, colorCredit, colorDebit);
    }
    downloadStatementPdf(content) {
        return this.dashboardService.downloadStatement(content);
    }
    // CNAB
    findByUuidAccountPaymentAndBetweenDate(dateStart, dateEnd) {
        return this.speViewNAccountProxy.findByUuidAccountPaymentAndBetweenDate(dateStart, dateEnd);
    }
    downloadExtractConciliation(idNoSql) {
        return this.speJCnabProxy.downloadExtractConciliation(idNoSql);
    }
    findVoucherPaginated(uuidAccountPayment, startDate, endDate, type, paginationParams) {
        return this.paymentService.findVoucherPaginated(uuidAccountPayment, startDate, endDate, type, paginationParams);
    }
    findScheduledPaginated(startDate, endDate, searchValue, paginationParams) {
        return this.speViewNAccountProxy.findScheduledPaginated(startDate, endDate, searchValue, paginationParams);
    }
    findTemplateVoucherByTransactionsId(transactionId) {
        return this.paymentService.findVouchersByTransactiosnId(transactionId);
    }
    findVoucherTemplatesByFilter(filter) {
        return this.paymentService.findVoucherTemplatesByFilter(filter);
    }
    findScheduledVoucherTemplatesByFilter(filter) {
        return this.speViewNAccountProxy.findScheduledVoucherTemplatesByFilter(filter);
    }
};
ExtractService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeNPaymentVoucherProxy,
        SpeViewNDashboardClientProxy,
        SpeJFilesProxy,
        SpeViewNAccountProxy,
        SpeJCnabProxy])
], ExtractService);

class TransferResponse {
}

let BanksService = class BanksService {
    constructor(speViewNPrePixProxy) {
        this.speViewNPrePixProxy = speViewNPrePixProxy;
    }
    /**
     * @description Método retorna a lista de bancos
     */
    getBankList() {
        /* return this.listBanks; */
        return this.speViewNPrePixProxy.getParticipant();
    }
    /**
     * @description Método retorna o nome do banco pelo código
     */
    filterListBank(value) {
        const result = this.listBanks.filter((item) => {
            return item.code === value;
        });
        return result[0].name;
    }
};
BanksService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeViewNPrePixProxy])
], BanksService);

let TransferService = class TransferService extends BaseService {
    constructor(formBuilder, speJCashOutProxy, speJCheckEventProxy, speNAccountsProxy, storage, configService, errorMessageService, banksService, printService, extractService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speJCashOutProxy = speJCashOutProxy;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.speNAccountsProxy = speNAccountsProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.banksService = banksService;
        this.printService = printService;
        this.extractService = extractService;
        this.errorMessages = {
            document: [
                {
                    type: 'required',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.DOCUMENTS.MESSAGE.REQUIRED',
                },
                {
                    type: 'cnpjNotValid',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.DOCUMENTS.MESSAGE.CNPJ_NOT_VALID',
                },
                {
                    type: 'cpfNotValid',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.DOCUMENTS.MESSAGE.CPF_NOT_VALID',
                },
            ],
            transferValue: [
                { type: 'required', message: 'CASH_OUT.TRANSFER_VALUE.FORM.VALUE_TRANSFER.MESSAGE.REQUIRED' },
                { type: 'invalid10', message: 'CASH_OUT.TRANSFER_VALUE.FORM.VALUE_TRANSFER.MESSAGE.INVALID10' },
                { type: 'invalid1', message: 'CASH_OUT.TRANSFER_VALUE.FORM.VALUE_TRANSFER.MESSAGE.INVALID1' },
                { type: 'invalid', message: 'CASH_OUT.TRANSFER_VALUE.FORM.VALUE_TRANSFER.MESSAGE.INVALID' },
            ],
            name: [
                { type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.NAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.NAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.NAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 },
                },
            ],
            branch: [
                { type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BRANCH.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BRANCH.MESSAGE.MIN_LENGTH',
                    param: { minLength: 4 },
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BRANCH.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 4 },
                },
            ],
            accountNumber: [
                { type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.ACCOUNT_NUMBER.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.ACCOUNT_NUMBER.MESSAGE.MIN_LENGTH',
                    param: { minLength: 3 },
                },
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.ACCOUNT_NUMBER.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 },
                },
            ],
            accountType: [{ type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.ACCOUNT_TYPE.MESSAGE.REQUIRED' }],
            bank: [{ type: 'required', message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.BANK.MESSAGE.REQUIRED' }],
        };
        this.behaviorTransfer = new BehaviorSubject(null);
        this.savedFavorite$ = new BehaviorSubject(false);
        this.transferFlow = new BehaviorSubject('');
        this.transferConfirmation = new BehaviorSubject(null);
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo de transferência
     */
    setTransfer(form) {
        this.behaviorTransfer.next(this.prepareForm(form));
    }
    /**
     * @description Método para desabilitar botão quando o favorito já é salvo.
     */
    setSavedFavorite(saved) {
        this.savedFavorite$.next(saved);
    }
    /**
     * @description Método buscar se o favorito ja existe
     */
    getSavedFavorite() {
        return this.savedFavorite$.asObservable();
    }
    /**
     * @description Método registra no objeto apenas o nome e o documento  para o fluxo de transferência por TED
     */
    setTransferOtherAccount(form) {
        let data = form.getRawValue();
        let dataTransfer = new TransferResponse();
        dataTransfer.document = data.document;
        dataTransfer.name = data.name;
        dataTransfer.transferValue = '';
        dataTransfer.bank = '';
        dataTransfer.bankCode = '';
        dataTransfer.branch = '';
        dataTransfer.accountNumber = '';
        dataTransfer.accountType = '';
        dataTransfer.date = '';
        dataTransfer.typeTransfer = 'TED';
        dataTransfer.uuidAccountPaymentDestination = '';
        dataTransfer.uuidWhiteLabelDestination = '';
        dataTransfer.dateSchedule = null;
        dataTransfer.scheduled = false;
        this.behaviorTransfer.next(dataTransfer);
    }
    /**
     * @description Método retorna o objeto com os dados já preenchidos no fluxo de transferência
     */
    getTransfer() {
        return this.behaviorTransfer.asObservable();
    }
    /**
     * @description Método registra o tipo de transferência está sendo feita
     */
    setTransferFlow(transferType) {
        this.transferFlow.next(transferType);
    }
    /**
     * @description Método retorna o tipo de transferência está sendo feita
     */
    getTransferFlow() {
        return this.transferFlow;
    }
    /**
     * @description Método retorna a lista de bancos registrados no UiBsUtil
     */
    getBankList() {
        return this.banksService.getBankList();
    }
    /**
     * @description Método cria o form para ser utilizado no fluxo de transferência
     */
    createFormTransfer() {
        this.formTransfer = this.formBuilder.group({
            document: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
            transferValue: new FormControl('', Validators.compose([Validators.required])),
            name: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])),
            branch: new FormControl('', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4)])),
            accountNumber: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(20)])),
            accountType: new FormControl('', Validators.compose([Validators.required])),
            bank: new FormControl('', Validators.compose([Validators.required])),
            bankCode: new FormControl(''),
            typeTransfer: new FormControl(''),
            dateSchedule: new FormControl(''),
            scheduled: new FormControl(''),
            uuidAccountPaymentDestination: new FormControl(''),
            uuidWhiteLabelDestination: new FormControl(''),
        });
        return this.formTransfer;
    }
    /**
     * @description Método recebe o form e transforma no corpo para o fluxo da transferência
     */
    prepareForm(form) {
        let data = form.getRawValue();
        let dataTransfer = new TransferResponse();
        dataTransfer.document = data.document;
        dataTransfer.transferValue = data.transferValue;
        dataTransfer.name = data.name;
        dataTransfer.bank = data.bank;
        dataTransfer.bankCode = data.bankCode;
        dataTransfer.branch = data.branch;
        dataTransfer.accountNumber = data.accountNumber;
        dataTransfer.accountType = data.accountType;
        dataTransfer.date = this.dateNow();
        dataTransfer.typeTransfer = data.typeTransfer;
        dataTransfer.uuidAccountPaymentDestination = data.uuidAccountPaymentDestination;
        dataTransfer.uuidWhiteLabelDestination = data.uuidWhiteLabelDestination;
        dataTransfer.dateSchedule = data.dateSchedule;
        dataTransfer.scheduled = data.scheduled;
        if (data.uuidQrCodeOnUs) {
            dataTransfer.uuidQrCodeOnUs = data.uuidQrCodeOnUs;
        }
        return dataTransfer;
    }
    /**
     * @description Método consulta o documento dentro do arranjo de pagamento
     */
    documentConsult(uuidWhiteLabel, document) {
        return __awaiter(this, void 0, void 0, function* () {
            const documentNoFormat = document.replace(/[^\w\s]/gi, '');
            let dataAccount;
            yield this.speJCashOutProxy
                .getAccountbydocument(uuidWhiteLabel, documentNoFormat)
                .toPromise()
                .then((res) => {
                dataAccount = res;
                if (dataAccount !== null) {
                    this.mountTransfer(dataAccount, document);
                }
            })
                .catch((err) => this.getErrorTransfer(err));
            let exist = !!dataAccount ? dataAccount : null;
            return Promise.resolve(exist);
        });
    }
    /**
     * @description Método busca contas dentro do mesmo arranjo de pagamento
     * @param uuidWhiteLabel
     * @param document
     * @param uuidAccount
     */
    checkAccountSameBucket(uuidWhiteLabel, document, uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const documentNoFormat = document.replace(/[^\w\s]/gi, '');
            let response;
            yield this.speJCashOutProxy
                .checkAccountSameBucket(uuidWhiteLabel, documentNoFormat, uuidAccount)
                .toPromise()
                .then((res) => {
                response = res;
            })
                .catch((err) => this.getErrorTransfer(err));
            let exist = !!response ? response : null;
            return Promise.resolve(exist);
        });
    }
    /**
     * @description Método preenche o form conforme o retorno da consulta por documento
     * @param dataAccount
     * @param document
     */
    mountTransfer(dataAccount, document) {
        this.formTransfer = this.formBuilder.group({
            document: new FormControl(document, Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
            name: new FormControl(dataAccount.name, Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(60)])),
            transferValue: new FormControl(dataAccount.transferValue, Validators.compose([Validators.required])),
            branch: new FormControl(dataAccount.bankBranch, Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4)])),
            accountNumber: new FormControl(dataAccount.bankAccount, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(20)])),
            accountType: new FormControl('CC', Validators.compose([Validators.required])),
            bank: new FormControl(dataAccount.bankName, Validators.compose([Validators.required])),
            bankCode: new FormControl(Validators.required),
            typeTransfer: new FormControl('On-Us'),
            dateSchedule: new FormControl(''),
            scheduled: new FormControl(''),
            uuidAccountPaymentDestination: new FormControl(dataAccount.uuidAccountPayment),
            uuidWhiteLabelDestination: new FormControl(dataAccount.uuidWhiteLabel),
        });
        this.setTransfer(this.formTransfer);
    }
    /**
     * @description Método retorna o form preenchido no processo de transferência
     */
    getFormTransfer() {
        let transferData;
        this.getTransfer().subscribe((res) => {
            transferData = res;
        });
        this.formTransfer = this.formBuilder.group({
            document: new FormControl(transferData.document, Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
            transferValue: new FormControl(transferData.transferValue, Validators.compose([Validators.required])),
            name: new FormControl(transferData.name, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(100)])),
            branch: new FormControl(transferData.branch, Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4)])),
            accountNumber: new FormControl(transferData.accountNumber, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(20)])),
            accountType: new FormControl(transferData.accountType, Validators.compose([Validators.required])),
            bank: new FormControl(transferData.bank, Validators.compose([Validators.required])),
            bankCode: new FormControl(transferData.bankCode),
            typeTransfer: new FormControl(transferData.typeTransfer),
            dateSchedule: new FormControl(''),
            scheduled: new FormControl(''),
            uuidAccountPaymentDestination: new FormControl(transferData.uuidAccountPaymentDestination),
            uuidWhiteLabelDestination: new FormControl(transferData.uuidWhiteLabelDestination),
            uuidQrCodeOnUs: new FormControl(transferData.uuidQrCodeOnUs ? transferData.uuidQrCodeOnUs : null),
        });
        return this.formTransfer;
    }
    disabledToogle(formTransfer) {
        return (formTransfer.controls.document.valid &&
            formTransfer.controls.name.valid &&
            formTransfer.controls.branch.valid &&
            formTransfer.controls.accountNumber.valid &&
            formTransfer.controls.accountType.valid);
    }
    getErrorTransfer(error) {
        this.errorMessageService.getError(error);
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    /**
     * @description Método retorna a data atual no formato dd/MM/aaaa
     */
    dateNow() {
        let data = new Date(), day = data.getDate().toString(), dayF = day.length == 1 ? '0' + day : day, month = (data.getMonth() + 1).toString(), monthF = month.length == 1 ? '0' + month : month, yearF = data.getFullYear();
        return dayF + '/' + monthF + '/' + yearF;
    }
    /**
     * @description Método responsavel por montar o corpo para envio e realiza a transferência
     */
    sendTransaction(uuidWhiteLabel, uuidAccount, token, tokenTransaction) {
        return __awaiter(this, void 0, void 0, function* () {
            let transferData;
            let sendingBody;
            let transferResponse;
            yield this.getTransfer().subscribe((res) => {
                transferData = res;
            });
            if (transferData.typeTransfer === 'TED' || transferData.typeTransfer === 'TEF') {
                sendingBody = {
                    accountType: transferData.accountType,
                    bankAccount: transferData.accountNumber.replace(/[^\w\s]/gi, ''),
                    bankBranch: transferData.branch,
                    bankCode: transferData.bankCode,
                    codeAuthorization: token,
                    tokenTransaction: tokenTransaction,
                    codeOperation: '120',
                    document: transferData.document.replace(/[^\w\s]/gi, ''),
                    name: transferData.name,
                    operationValue: this.formatValue(transferData.transferValue),
                    dateSchedule: transferData.dateSchedule,
                    scheduled: transferData.scheduled,
                    uuidAccountPayment: uuidAccount,
                    uuidWhiteLabel: uuidWhiteLabel,
                };
            }
            else {
                sendingBody = {
                    accountType: transferData.accountType,
                    bankAccount: transferData.accountNumber.replace(/[^\w\s]/gi, ''),
                    bankBranch: transferData.branch,
                    bankCode: transferData.bankCode,
                    codeAuthorization: token,
                    tokenTransaction: tokenTransaction,
                    codeOperation: '901',
                    document: transferData.document.replace(/[^\w\s]/gi, ''),
                    name: transferData.name,
                    operationValue: transferData.typeTransfer.toUpperCase() === 'QRCODE-ON-US'
                        ? transferData.transferValue
                        : this.formatValue(transferData.transferValue),
                    dateSchedule: transferData.dateSchedule,
                    scheduled: transferData.scheduled,
                    uuidAccountPayment: uuidAccount,
                    uuidAccountPaymentDestination: transferData.uuidAccountPaymentDestination,
                    uuidWhiteLabel: uuidWhiteLabel,
                    uuidWhiteLabelDestination: transferData.uuidWhiteLabelDestination,
                    uuidQrCodeOnUs: transferData.uuidQrCodeOnUs ? transferData.uuidQrCodeOnUs : null,
                };
            }
            yield this.speJCashOutProxy
                .effectTransfer(uuidWhiteLabel, sendingBody.document, sendingBody)
                .toPromise()
                .then((res) => {
                transferResponse = res;
                if (transferResponse.isExecuted === true) {
                    this.saveReceipt(transferResponse.result.transactionId);
                }
            })
                .catch((err) => this.getErrorTransfer(err));
            let response = !!transferResponse ? transferResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Método fomata o valor de string e retorna um float
     */
    formatValue(value) {
        let transferValue = value.replace(/\./g, '');
        let transferValue2 = transferValue.replace(',', '.');
        return parseFloat(transferValue2);
    }
    /**
     * @description Método salva os dados para impressaão do comprovante
     */
    saveReceipt(transactionId) {
        this.extractService.getTransaction(transactionId).subscribe((res) => {
            this.transferConfirmation.next(res);
        }, (err) => {
            console.error('Failed to load data', err);
        });
    }
    /**
     * @description Método responsavel por retornar os dados do comprovante de transferência
     */
    getTransferConfirmation() {
        return this.transferConfirmation.asObservable();
    }
    /**
     * @description Método de impressão.
     * @param html
     * @param css
     */
    print(html, css) {
        this.printService.print(html, css);
    }
    /**
     * @description Método reinicia os dados para o processo
     */
    unsubscribe() {
        this.behaviorTransfer.next(null);
        this.transferFlow = new BehaviorSubject('');
        this.transferConfirmation = new BehaviorSubject(null);
        this.savedFavorite$ = new BehaviorSubject(false);
        this.formTransfer = null;
        this.createFormTransfer();
    }
    /**
     * @description Método responsavel por validar a transferência
     */
    validateOperation(uuidWhiteLabel, uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let transferData;
            let sendingBody;
            let validateResponse;
            yield this.getTransfer().subscribe((res) => {
                transferData = res;
            });
            if (transferData.typeTransfer === 'TED' || transferData.typeTransfer === 'TEF') {
                sendingBody = {
                    codeOperation: '120',
                    uuidAccountPayment: uuidAccount,
                    uuidWhiteLabel: uuidWhiteLabel,
                    valueOperation: this.formatValue(transferData.transferValue),
                };
            }
            else {
                sendingBody = {
                    codeOperation: '901',
                    uuidAccountPayment: uuidAccount,
                    uuidWhiteLabel: uuidWhiteLabel,
                    valueOperation: transferData.typeTransfer.toUpperCase() === 'QRCODE-ON-US'
                        ? transferData.transferValue
                        : this.formatValue(transferData.transferValue),
                };
            }
            yield this.speJCheckEventProxy
                .validateOperation(sendingBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => this.getErrorTransfer(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Metodo responsavel por encaminhar a hash do qrcode e coletar as informaçoes
     */
    consultQrcode(uuidAccountPaymentPay, encode) {
        return this.speNAccountsProxy.decodeQrcode(uuidAccountPaymentPay, encode);
    }
    checkDayResource(uuidWhiteLabel, code, type, dateOperation) {
        return this.speJCheckEventProxy.checkDayResource(uuidWhiteLabel, code, type, dateOperation);
    }
};
TransferService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeJCashOutProxy,
        SpeJCheckEventProxy,
        SpeNAccountsProxy,
        Storage,
        ConfigService,
        ErrorMessageService,
        BanksService,
        PrintService,
        ExtractService])
], TransferService);

let TaxesTariffService = class TaxesTariffService extends BaseService {
    constructor(storage, configService, service) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.service = service;
    }
    /**
     * retorna as informações de taxas e tarifas do wl informado
     * @param transationId
     */
    getTaxesTariff(uuidWl, uuidAccount) {
        return this.service.getTaxesTariff(uuidWl, uuidAccount);
    }
};
TaxesTariffService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeViewNAccountProxy])
], TaxesTariffService);

class RequestLimitRateResponse {
}

let ClientLimitRateService = class ClientLimitRateService extends BaseService {
    constructor(storage, configService, speViewNAccountProxy, speJFundsProxy, speNAccountsProxy, errorMessageService, formBuilder) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.speJFundsProxy = speJFundsProxy;
        this.speNAccountsProxy = speNAccountsProxy;
        this.errorMessageService = errorMessageService;
        this.formBuilder = formBuilder;
        this.errorMessages = {
            amountDailyLimit: [
                { type: 'required', message: 'LIMITS_RATE.FORM.AMOUNT_DAILY_LIMIT.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'LIMITS_RATE.FORM.AMOUNT_DAILY_LIMIT.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 }
                },
            ],
            amountThirtyLimit: [
                { type: 'required', message: 'LIMITS_RATE.FORM.AMOUNT_DAILY_LIMIT.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'LIMITS_RATE.FORM.AMOUNT_DAILY_LIMIT.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 }
                },
            ],
            valueDailyLimit: [
                { type: 'required', message: 'LIMITS_RATE.FORM.VALUE_DAILY_LIMIT.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'LIMITS_RATE.FORM.VALUE_DAILY_LIMIT.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 }
                },
            ],
            valueThirtyLimit: [
                { type: 'required', message: 'LIMITS_RATE.FORM.VALUE_THIRTY_LIMIT.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'LIMITS_RATE.FORM.VALUE_THIRTY_LIMIT.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 }
                },
            ]
        };
    }
    /**
     * @description Método cria o form para ser utilizado no fluxo
     */
    buildForm() {
        this.form = this.formBuilder.group({
            amountDailyLimit: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)])),
            amountThirtyLimit: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)])),
            valueDailyLimit: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)])),
            valueThirtyLimit: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)]))
        });
        return this.form;
    }
    formatReal(vl) {
        let value = vl.toFixed(2);
        value = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
        value = value.toString().replace('R$', '');
        return value.replace(/\s/g, '');
    }
    /**
     * @description Retorna as informações de limites da conta
     * @param uuidWl
     * @param uuidAccountPayment
     */
    getClientLimitRate(uuidWl, uuidAccountPayment) {
        return this.speViewNAccountProxy.getClientLimitRate(uuidWl, uuidAccountPayment);
    }
    /**
     * @description Retorna as informações de limites da conta disponíveis
     * @param uuidWl
     * @param uuidAccountPayment
     */
    getClientLimitAvaiable(uuidWl, uuidAccountPayment) {
        return this.speJFundsProxy.getClientLimitAvaiable(uuidWl, uuidAccountPayment);
    }
    getClientLimitAvaiablePIX(uuidWl, uuidAccountPayment) {
        return this.speJFundsProxy.getClientLimitAvaiablePIX(uuidWl, uuidAccountPayment);
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    /**
     * @description Método responsavel enviar a solicitação de alteração do limite da conta
     * @param RequestLimitRate
     */
    requestLimitRate(requestLimitRate) {
        return __awaiter(this, void 0, void 0, function* () {
            let validateResponse;
            yield this.speNAccountsProxy.requestLimitRate(this.createRequestBody(requestLimitRate))
                .toPromise()
                .then(res => {
                validateResponse = res;
            })
                .catch(err => err);
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    createRequestBody(obj) {
        let requestBody = new RequestLimitRateResponse;
        requestBody = {
            uuidAccountPayment: obj.uuidAccountPayment,
            uuidWhiteLabel: obj.uuidWhiteLabel,
            amountDailyLimit: this.formatValue(obj.amountDailyLimit),
            amountThirtyLimit: this.formatValue(obj.amountThirtyLimit),
            valueDailyLimit: this.formatValue(obj.valueDailyLimit),
            valueThirtyLimit: this.formatValue(obj.valueThirtyLimit),
        };
        return requestBody;
    }
    formatValue(value) {
        let aValue = value.replace(/\./g, '');
        let bValue = aValue.replace(',', '.');
        return parseFloat(bValue);
    }
};
ClientLimitRateService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeViewNAccountProxy,
        SpeJFundsProxy,
        SpeNAccountsProxy,
        ErrorMessageService,
        FormBuilder])
], ClientLimitRateService);

let TransactionScheduleService = class TransactionScheduleService extends BaseService {
    constructor(storage, configService, SpeViewNAccountProxy, SpeNAccountProxy, speNAccountsProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.SpeViewNAccountProxy = SpeViewNAccountProxy;
        this.SpeNAccountProxy = SpeNAccountProxy;
        this.speNAccountsProxy = speNAccountsProxy;
    }
    getTransactionSchedule(uuidAccount) {
        return this.SpeViewNAccountProxy.getTransactionSchedule(uuidAccount);
    }
    deleteTransactionSchedule(uuidAccountPayment, uuid) {
        return this.speNAccountsProxy.deleteTransactionSchedule(uuidAccountPayment, uuid);
    }
};
TransactionScheduleService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeViewNAccountProxy,
        SpeNAccountProxy,
        SpeNAccountsProxy])
], TransactionScheduleService);

let DdaService = class DdaService extends BaseService {
    constructor(storage, configService) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
    }
    getListDebitAutomatic(uuid) {
        return of([
            {
                tituloSacadorID: 3,
                sacadorEletronicoId: 10,
                numIdentDDA: '1234',
                beneficiario: 'Francisca',
                nomeFantasia: 'Ferro Brasa',
                endereco: 'rua noé, 12',
                cidade: 'Campinas',
                uf: 'SP',
                cep: '0330001',
                cnpjCpfSacador: '11112222333344',
                cnpjCpfCedente: '99998888777766',
                seuNumero: '3333222',
                nomeSacado: 'João Maria',
                dataDesconto01: '2019-10-15T21:23:36.042Z',
                dataDesconto02: '2019-10-10T21:23:36.042Z',
                dataDesconto03: '2019-10-14T21:23:36.042Z',
                dataEmissao: '2019-10-17T21:23:36.042Z',
                dataMora: '2019-09-15T21:23:36.042Z',
                dataMulta: '2019-09-15T21:23:36.042Z',
                dataVencimento: '2019-10-18T21:23:36.042Z',
                dataLimitePagamento: '2019-10-25T21:23:36.042Z',
                codigoDeBarras: '63391805800000010000001112122418900109574329',
                linhaDigitavel: '63390001161212241890301095743298180580000001000',
                nossoNumero: '4444555',
                permitePagamentoParcial: true,
                valorAbatimento: 0,
                valorDesconto01: 0,
                valorDesconto02: 0,
                valorDesconto03: 0,
                valorPercentualMora: 0,
                valorPercentualMulta: 0,
                valor: 2000,
                status: 'À vencer',
                valorAtual: 0,
                valorMinTitulo: 0,
                valorMaxTitulo: 0,
            },
        ]);
    }
};
DdaService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService])
], DdaService);

let ClientLimitPixService = class ClientLimitPixService extends BaseService {
    constructor(storage, configService, speNAccountsProxy, errorMessageService, formBuilder) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speNAccountsProxy = speNAccountsProxy;
        this.errorMessageService = errorMessageService;
        this.formBuilder = formBuilder;
        this.errorMessages = {
            pixDayTimeSingleOperationLimit: [
                { type: 'required', message: 'LIMITS_RATE.FORM.AMOUNT_DAILY_LIMIT.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'LIMITS_RATE.FORM.AMOUNT_DAILY_LIMIT.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 },
                },
            ],
            pixDayTimeTotalLimit: [
                { type: 'required', message: 'LIMITS_RATE.FORM.AMOUNT_DAILY_LIMIT.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'LIMITS_RATE.FORM.AMOUNT_DAILY_LIMIT.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 },
                },
            ],
            pixNightSingleOperationLimit: [
                { type: 'required', message: 'LIMITS_RATE.FORM.VALUE_DAILY_LIMIT.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'LIMITS_RATE.FORM.VALUE_DAILY_LIMIT.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 },
                },
            ],
            pixNightTimeSelected: [
                { type: 'required', message: 'LIMITS_RATE.FORM.VALUE_THIRTY_LIMIT.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'LIMITS_RATE.FORM.VALUE_THIRTY_LIMIT.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 },
                },
            ],
            pixNightTotalLimit: [{ type: 'required', message: 'LIMITS_RATE.FORM.VALUE_THIRTY_LIMIT.MESSAGE.REQUIRED' }],
        };
    }
    formatReal(vl) {
        let value = vl.toFixed(2);
        value = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
        value = value.toString().replace('R$', '');
        return value.replace(/\s/g, '');
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    requestLimitPix(requestLimitRate, accountPayment) {
        return __awaiter(this, void 0, void 0, function* () {
            let validateResponse;
            yield this.speNAccountsProxy
                .requestLimitPix(this.prepareLimitPix(requestLimitRate, accountPayment))
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => err);
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    prepareLimitPix(obj, accountPayment) {
        const requestBody = {
            uuidAccountPayment: accountPayment.uuidAccount,
            uuidWhiteLabel: accountPayment.uuidWhiteLabel,
            pixDayTimeSingleOperationLimit: this.formatValue(obj.pixDayTimeSingleOperationLimit),
            pixDayTimeTotalLimit: this.formatValue(obj.pixDayTimeTotalLimit),
            pixNightSingleOperationLimit: this.formatValue(obj.pixNightSingleOperationLimit),
            pixNightTimeSelected: obj.pixNightTimeSelected,
            pixNightTotalLimit: this.formatValue(obj.pixNightTotalLimit),
        };
        return requestBody;
    }
    createFormLimitPix() {
        this.form = this.formBuilder.group({
            pixDayTimeSingleOperationLimit: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)])),
            pixDayTimeTotalLimit: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)])),
            pixNightSingleOperationLimit: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20), this.maxValueValidator()])),
            pixNightTimeSelected: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)])),
            pixNightTotalLimit: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20), this.maxValueValidator()])),
        });
        return this.form;
    }
    formatValue(value) {
        let aValue = value.replace(/\./g, '');
        let bValue = aValue.replace(',', '');
        let valueDiv = bValue / 100;
        return parseFloat(valueDiv);
    }
    maxValueValidator() {
        return (control) => {
            if (control.value === '' || control.value === null)
                return null;
            const cost = String(control.value).replace(/\./g, '').replace(/,/g, '');
            const costNumber = parseFloat(cost);
            return costNumber > 100000 ? { maxValue: true } : null;
        };
    }
};
ClientLimitPixService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeNAccountsProxy,
        ErrorMessageService,
        FormBuilder])
], ClientLimitPixService);

let DualAuthService = class DualAuthService extends BaseService {
    constructor(paymentService, speJCashOutProxy, speViewNBackoficceAccountProxy, speViewNAccountProxy, storage, configService) {
        super(storage, configService);
        this.paymentService = paymentService;
        this.speJCashOutProxy = speJCashOutProxy;
        this.speViewNBackoficceAccountProxy = speViewNBackoficceAccountProxy;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.storage = storage;
        this.configService = configService;
    }
    findAllPendingTransactions() {
        return this.paymentService.findAllPendingTransactions();
    }
    confirmTransaction(statusAproved, transactionsBody) {
        return this.speJCashOutProxy.confirmTransaction(statusAproved, transactionsBody);
    }
    getDualAuthAccountInfo(uuidAccountPayment) {
        return this.speViewNBackoficceAccountProxy.getDualAuthAccountInfo(uuidAccountPayment);
    }
    getAllTransactionsPaginated(uuidAccountPayment, typeOperation, statusTransaction, dateStart, dateEnd, itemsPerPage = 20, pageNumber = 1) {
        return this.speViewNAccountProxy.getAllTransactionsPaginated(uuidAccountPayment, typeOperation, statusTransaction, dateStart, dateEnd, itemsPerPage, pageNumber);
    }
    getAllTransactionsPaginatedOfUser(uuidAccountPayment, typeOperation, statusTransaction, dateStart, dateEnd, itemsPerPage = 20, pageNumber = 1) {
        return this.speViewNAccountProxy.getAllTransactionsPaginatedOfUser(uuidAccountPayment, typeOperation, statusTransaction, dateStart, dateEnd, itemsPerPage, pageNumber);
    }
    statusUpdateTransactionPending(uuidAccountPayment, updateStatusData) {
        return this.speJCashOutProxy.statusUpdateTransactionPending(uuidAccountPayment, updateStatusData);
    }
    canceledLotTransactionsPendingOfDualAuth(updateStatusData) {
        return this.speJCashOutProxy.canceledLotTransactionsPendingOfDualAuth(updateStatusData);
    }
};
DualAuthService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNPaymentVoucherProxy,
        SpeJCashOutProxy,
        SpeViewNBackoficceAccountProxy,
        SpeViewNAccountProxy,
        Storage,
        ConfigService])
], DualAuthService);

let CnabService = class CnabService extends BaseService {
    constructor(formBuilder, storage, configService, base64Service, alertController, translate, speJCnabProxy, speViewNCnabProxy) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.configService = configService;
        this.base64Service = base64Service;
        this.alertController = alertController;
        this.translate = translate;
        this.speJCnabProxy = speJCnabProxy;
        this.speViewNCnabProxy = speViewNCnabProxy;
        this.sizeFile = 5242880;
        this.OPERATION = '80006';
        // private readonly OPERATION: string = '7a2ee235-758b-11ed-93e4-0200f98db647';
        this.errorMessages = {
            product: [
                { type: 'required', message: 'CNAB.SHIPPING.MESSAGE_SEND_SHIPPING.LABEL_PRODUCT.REQUIRED' },
            ],
            file: [
                { type: 'required', message: 'CNAB.SHIPPING.MESSAGE_SEND_SHIPPING.LABEL_FILE.REQUIRED' },
            ],
        };
        this.products = [{
                name: 'Pagamentos e Transfências',
                value: 1,
            }];
    }
    createForm() {
        return this.formBuilder.group({
            product: new FormControl('', Validators.compose([Validators.required])),
            file: new FormControl('', Validators.compose([Validators.required])),
        });
    }
    getErrorMessages() {
        return this.errorMessages;
    }
    getProducts() {
        return this.products;
    }
    getCodeOperation() {
        return this.OPERATION;
    }
    donwoloadCnab(codeProduct, idNoSql) {
        return this.speJCnabProxy.donwoloadCnab(codeProduct, idNoSql);
    }
    uploadFile(fileList, uuidWhiteLabel, code, codeProduct) {
        return __awaiter(this, void 0, void 0, function* () {
            const extentions = ['txt', 'rem'];
            this.fileSelected = fileList.item(0);
            if (this.fileSelected.size > this.sizeFile) {
                this.removeFile();
                return;
            }
            const typeFile = this.fileSelected.type;
            const extentionFile = this.fileSelected.name.substr(this.fileSelected.name.length - 4, this.fileSelected.name.length).toLowerCase();
            // console.log('uploadFile::typeFile:: '+ typeFile + ' - Extention::' + extentionFile);
            if (extentions.indexOf(extentionFile.replace('.', '')) == -1) {
                console.warn('uploadFile::typeFile:: ' + typeFile + ' - Extention::' + extentionFile);
                this.alertDocumentInvalid();
                this.removeFile();
                return;
            }
            const fileBase64 = yield this.base64Service.convertFileToBase64(this.fileSelected);
            const requestProcess = {
                codeAuthorized: code,
                codeProduct: codeProduct,
                uuidWhitelabel: uuidWhiteLabel,
                file: fileBase64,
                filename: this.fileSelected.name,
                filesize: this.fileSelected.size
            };
            return this.speJCnabProxy.processFile(+codeProduct, requestProcess).toPromise();
        });
    }
    alertDocumentInvalid() {
        return __awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                cssClass: 'my-custom-class',
                header: this.translate.applyTranslate('CNAB.SHIPPING.ALERTS.INVALID_TYPE.TITLE'),
                message: this.translate.applyTranslate('CNAB.SHIPPING.ALERTS.INVALID_TYPE.MESSAGE'),
                buttons: [this.translate.applyTranslate('CNAB.SHIPPING.ALERTS.INVALID_TYPE.BUTTON')],
            });
            yield alert.present();
        });
    }
    removeFile() {
        this.form.patchValue({
            file: null,
        });
        this.fileSelected = null;
        // this.goRemoveFile.emit();
    }
    getLotCnabByIdAndCodeProduct(idLot, codeProduct) {
        return this.speViewNCnabProxy.getLotCnabByIdAndCodeProduct(codeProduct, idLot);
    }
    getCnabDataByCodeProductAndPeriod(codeProduct, dateStart, dateEnd) {
        return this.speViewNCnabProxy.getCnabDataByCodeProductAndPeriod(codeProduct, dateStart, dateEnd);
    }
};
CnabService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        Storage,
        ConfigService,
        Base64Service,
        AlertController,
        UiBsTranslateService,
        SpeJCnabProxy,
        SpeViewNCnabProxy])
], CnabService);

let PaymentLotService = class PaymentLotService extends BaseService {
    constructor(storage, configService, proxySpeNPaymentLot, proxySpeViewNPaymentLot) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.proxySpeNPaymentLot = proxySpeNPaymentLot;
        this.proxySpeViewNPaymentLot = proxySpeViewNPaymentLot;
    }
    // ------------------------------------------------------------------------------
    // BILLET:: Start
    // ------------------------------------------------------------------------------
    getBilletLotAvailable() {
        return this.proxySpeViewNPaymentLot.getBilletLotAvailable();
    }
    addBilletLotByUser(paymentDetail) {
        return this.proxySpeNPaymentLot.addBilletLotByUser(paymentDetail);
    }
    deletedBilletLotByUser() {
        return this.proxySpeNPaymentLot.deletedBilletLotByUser();
    }
    // Transaciton
    addBilletLotTransaction(paymentDetail) {
        return this.proxySpeNPaymentLot.addBilletLotTransaction(paymentDetail);
    }
    updateBilletLotTransaction(paymentDetail) {
        return this.proxySpeNPaymentLot.addBilletLotTransaction(paymentDetail);
    }
    deletedBilletLotTransaction(uuidTransaction) {
        return this.proxySpeNPaymentLot.deletedBilletLotTransaction(uuidTransaction);
    }
    processBillet(codeAuthorization, uuidPaymentLot, uuidWhiteLabel) {
        return this.proxySpeNPaymentLot.processBillet(codeAuthorization, uuidPaymentLot, uuidWhiteLabel);
    }
};
PaymentLotService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeNPaymentProxy,
        SpeViewNPaymentProxy])
], PaymentLotService);

var UiBsCashOutModule_1;
let UiBsCashOutModule = UiBsCashOutModule_1 = class UiBsCashOutModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsCashOutModule_1,
            providers: [{ provide: APP_PARAMETER, useValue: config }],
        };
    }
};
UiBsCashOutModule = UiBsCashOutModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql'],
            }),
            UiPxCashOutModule,
            UiPxPixModule,
        ],
        providers: [
            TransferService,
            BilletService,
            ExtractDigitalAccountService,
            ExtractService,
            AddCardService,
            AccountDataService,
            TaxesTariffService,
            ClientLimitRateService,
            TransactionScheduleService,
            DdaService,
            BanksService,
            ClientLimitPixService,
            DualAuthService,
            CnabService,
            PaymentLotService
        ],
        exports: [RxReactiveFormsModule],
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsCashOutModule])
], UiBsCashOutModule);

class BilletResponse {
}

class DataFormatBilletResponse {
}

class DataFormatSaveBilletResponse {
}

class DataStatementResponse {
}

class DataAccountResponse {
}

class AccountPaymentPersonResponse {
}

class ClientLimitRateResponse {
}

class ClientLimitAvaiableResponse {
}

class ClientLimitPixAvaiableResponse {
}

class DataStatementFutureResponse {
}

class DebitAutomaticResponse {
}

var TypeView;
(function (TypeView) {
    TypeView["DETAILADED"] = "DETAILADED";
    TypeView["CONSOLIDADED"] = "CONSOLIDADED";
})(TypeView || (TypeView = {}));

var ExportFormat;
(function (ExportFormat) {
    ExportFormat["XLSX"] = "xlsx";
    ExportFormat["OFX"] = "ofx";
    ExportFormat["PDF"] = "pdf";
})(ExportFormat || (ExportFormat = {}));

export { AccountDataService, AccountPaymentPersonResponse, AddCardResponse, AddCardService, BanksService, BilletResponse, BilletService, ClientLimitAvaiableResponse, ClientLimitPixAvaiableResponse, ClientLimitPixService, ClientLimitRateResponse, ClientLimitRateService, CnabService, DataAccountResponse, DataFormatBilletResponse, DataFormatSaveBilletResponse, DataStatementFutureResponse, DataStatementResponse, DdaService, DebitAutomaticResponse, DualAuthService, ExportFormat, ExtractDigitalAccountResponse, ExtractDigitalAccountService, ExtractFutureResponse, ExtractService, PaymentLotService, RequestLimitRateResponse, TaxesTariffService, TransactionScheduleService, TransferResponse, TransferService, TypeView, UiBsCashOutModule };
//# sourceMappingURL=wlp-ui-bs-cashout.js.map
